import { MetricRow } from './metricRows';

export const MAX_TICKS = 14;

const stepForRange = (count: number): number => {
  if (count <= 31) {
    return 7;
  }
  if (count <= 90) {
    return 14;
  }
  return 30;
};

export function getAdaptiveTicks(rows: MetricRow[], maxTicks: number = MAX_TICKS): string[] {
  const count = rows.length;
  if (count <= 1) {
    return count === 1 ? [rows[0].label] : [];
  }

  let step = stepForRange(count);
  const lastIndex = count - 1;

  while (true) {
    const indices: number[] = [];
    for (let i = 0; i < count; i += step) {
      indices.push(i);
    }
    if (indices[indices.length - 1] !== lastIndex) {
      indices.push(lastIndex);
    }

    // Once step reaches lastIndex the loop yields the minimal [first, last]
    // pair; it cannot shrink further, so stop even when maxTicks is
    // unsatisfiable (e.g. 0, 1, or negative) instead of looping forever.
    if (indices.length <= maxTicks || step >= lastIndex) {
      const seen = new Set<string>();
      const ticks: string[] = [];
      for (const index of indices) {
        const label = rows[index].label;
        if (!seen.has(label)) {
          seen.add(label);
          ticks.push(label);
        }
      }
      return ticks;
    }

    step += 1;
  }
}
